var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('h3',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.subtitle))]),(_vm.divider)?_c('v-divider',{staticClass:"mt-3"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }